import { Locale } from 'components/core/locale/types';

export const PatientVitalsTranslations = {
  [Locale.English]: {
    PatientVitalsPage: {
      for: 'For',
      pageTitle: 'Vitals',
      height: 'Height',
      heightFeet: 'Feet',
      heightInches: 'Inches',
      weight: 'Weight',
      lbs: 'Lbs',
      informationText: 'Please update these numbers if you have them.',
      systolicBloodPressure: 'Systolic Blood Pressure',
      diastolicBloodPressure: 'Diastolic Blood Pressure',
      restingHeartRate: 'Resting Heart Rate (Beats per Minute)',
      done: 'Done',
      serverError: 'Server Error try again',
    },
  },
};
